import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import RejectedTimesheetRow from './RejectedTimesheetRow';

const StyledWrapper = styled.div`
  padding-top: ${props => props.theme.spacing[2]};
`;

const RejectedTimesheets = ({
  timesheets,
  getChecked,
  onTimesheetRowClick,
  onTimesheetSelectChange,
}) => (
  <StyledWrapper>
    {
      timesheets.map(({ id, ...rest }) => (
        <RejectedTimesheetRow
          isChecked={getChecked(id)}
          key={id}
          {...rest}
          onClick={() => onTimesheetRowClick(id)}
          onCheckChange={() => onTimesheetSelectChange(id)}
        />
      ))
    }
  </StyledWrapper>
);

RejectedTimesheets.propTypes = {
  getChecked: PropTypes.func.isRequired,
  timesheets: PropTypes.array.isRequired,
  totalTimesheetsCount: PropTypes.number.isRequired,
  onExportClick: PropTypes.func.isRequired,
  onTimesheetRowClick: PropTypes.func.isRequired,
  onTimesheetSelectChange: PropTypes.func.isRequired,
  mobileUser: PropTypes.bool.isRequired,
  onBottomReached: PropTypes.func.isRequired,
  isEndReached: PropTypes.bool.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  onTimesheetSelectAll: PropTypes.func.isRequired,
  areAllTimesheetsSelected: PropTypes.bool.isRequired,
  downloadReady: PropTypes.bool.isRequired,
  timesheetsToDownload: PropTypes.array.isRequired,
  selectedTimesheetsCount: PropTypes.number.isRequired,
};

export default RejectedTimesheets;
